import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPopupStateChanged, setPopupStateDiff } from '#action/project/devices-popup';
import { getSymmetricDifference, getAlertDiff } from '#component/device/devices-popup/helper';

export const useDevicePopupChangesShipment = (formDataObj, openedFromForm) => {
  const dispatch = useDispatch();
  // formDataObj.initialFormDevices / formDataObj.formDevices are set by the RHF-based cargo form
  const formDevices = formDataObj?.formDevices;
  const formValues = formDataObj?.initialFormDevices;

  useEffect(() => {
    if (!openedFromForm || !formDevices?.length || !formValues?.length) {
      return;
    }
    const symmetricDiff = getSymmetricDifference(formDevices, formValues) ?? [];
    const alertsDiff = getAlertDiff(formDevices, formValues);
    const isChanged = Boolean(symmetricDiff.length) || Boolean(alertsDiff.length);

    dispatch(setPopupStateChanged(isChanged));
    dispatch(setPopupStateDiff(symmetricDiff));
  }, [dispatch, formDevices, formValues, openedFromForm]);
};
